export class ClearNotificationData {
    public static readonly type = '[RootState] Clear notification data';
}
